"use client";

import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";
import { beatportClickDetails } from "@/lib/affiliate-tracking";

export default function AffiliateClickTracker() {
  const posthog = usePostHog();
  useEffect(() => {
    const recent = new Map<string, number>();
    const onClick = (event: MouseEvent) => {
      if (!event.isTrusted || event.defaultPrevented || (event.type === "auxclick" && event.button !== 1)) return;
      const anchor = event.target instanceof Element ? event.target.closest<HTMLAnchorElement>("a[href]") : null;
      if (!anchor) return;
      const record = anchor.closest<HTMLElement>("[data-catalogue-kind][data-catalogue-id]");
      const properties = beatportClickDetails(anchor.href, location.pathname, { kind: record?.dataset.catalogueKind, id: record?.dataset.catalogueId });
      if (!properties) return;
      const key = `${properties.source_path}:${properties.destination_path}`;
      const now = Date.now();
      if (now - (recent.get(key) || 0) < 1000) return;
      for (const [key, time] of recent) if (now - time > 1000) recent.delete(key);
      recent.set(key, now);
      window.gtag?.("event", "beatport_outbound", { ...properties, transport_type: "beacon" });
      posthog?.capture("affiliate_click", properties);
    };
    document.addEventListener("click", onClick);
    document.addEventListener("auxclick", onClick);
    return () => { document.removeEventListener("click", onClick); document.removeEventListener("auxclick", onClick); };
  }, [posthog]);
  return null;
}
